module.exports = __webpack_public_path__ + "img/power-edge-r340.a9cc1e4f.jpg";